<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px">
                <col>
            </colgroup>
            <tr v-if="hasLookbookData()">
                <td class="c_t_title">플레이옷 번호</td>
                <td>
                    {{ lookbookData.l_idx }}
                </td>
            </tr>
            <tr>
                <td class="c_t_title">노출상태</td>
                <td>
                    <div>
                        <el-radio-group v-model="display" class="mr20" v-if=""
                                        @change="parentChange('display', display)">
                            <el-radio :label="1" value="1">노출</el-radio>
                            <el-radio :label="0" value="0">노출중지</el-radio>
                        </el-radio-group>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">제목</td>
                <td>
                    <div class="d_block">
                        <el-input v-model="title" @input="parentChange('title', title)"></el-input>
                        <div class="input_error">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">내용</td>
                <td>
                    <div class="d_block">
                        <el-input v-model="content" type="textarea" :rows="5" resize="none" @input="parentChange('content', content)"></el-input>
                        <div class="input_error">{{ validation.firstError('content') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">썸네일</td>
                <td>

                    <div class="d_block youtube_img">
                        <img style="pointer-events: none;width: 100%;height: 100%" :src="returnThumnailUrl()"
                             v-if="checkYoutube()">
                    </div>

                </td>
            </tr>
            <tr>
                <td class="c_t_title">URL</td>
                <td>
                    <div class="d_block">
                        <el-input v-model="url" @input="parentChange('url', url)"
                                  :placeholder="`https://youtu.be/vImc9gsizFg`" @blur="getYoutubeId()"></el-input>
                        <div class="input_error">{{ validation.firstError('url') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">채널</td>
                <td>
                    <div>
                        <el-select id="category" v-model="channelKey" class="my_filter select" placeholder="선택"
                                   @change="parentChange('channelKey', channelKey)">
                            <el-option v-for="data in channelData"
                                       :value="data.lc_idx" :label="data.lc_title"
                                       :key="`channel${data.lc_idx}`">{{ data.lc_title }}
                            </el-option>
                        </el-select>
                        <div class="input_error">{{ validation.firstError('channelKey') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">해시태그</td>
                <td>
                    <div>
                        <el-checkbox-group v-model="hashtag" @change="parentChange('hashtag', hashtag)">
                            <el-checkbox v-for="label in hashList" :key="label.lh_hash"
                                         :label="label.lh_idx">{{ label.lh_hash }}
                            </el-checkbox>
                        </el-checkbox-group>
                        <div class="input_error">{{ validation.firstError('hashtag') }}</div>
                    </div>
                </td>
            </tr>

        </table>

    </div>

</template>

<script>
import summernote from '@/mixins/summernote';
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import elFileMixins from "@/mixins/elFileMixins";
import lookbookValidator from "@/mixins/validators/LookbookValidator";
import LookbookItemComponent from "@/components/lookbook/LookbookItemComponent";

export default {
    name: "LookbookWriteDefaultLayout",
    mixins: [summernote, elFileMixins, lookbookValidator],
    components: {LookbookItemComponent},
    inject: ['lookbookWriteSetData'],
    provide() {
        return {}
    },
    props: {
        lookbookData: {
            default: () => {
            }
        },
        channelData: {default: () => []},
    },
    data() {
        return {
            fixCheck: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            hashList: [],
            itemKey: [],
        }
    },
    created() {
        this.getHashList();
    },
    mounted() {
        EventBus.$on('LookbookWriteDefaultLayoutValidator', this.checkValidator)
        this.setInitData();
    },
    beforeDestroy() {
        EventBus.$off('LookbookWriteDefaultLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        parentChange(type, value) {
            this.lookbookWriteSetData(type, value);
        },
        hasLookbookData() {
            return !util.isEmpty(this.lookbookData)
        },
        getHashList() {
            EventBus.$emit('apiLoading', true)
            this.tableLoading = true;
            let params = {}
            try {
                this.$api.$lookbook.getHash(params).then(data => {
                    let res = data.Data.Result;
                    if (res.Info.Type === 1) {
                        this.hashList = res.List;
                    }
                });
            } catch (e) {
                console.log(e);
            }
            EventBus.$emit('apiLoading', false);
        },
        setInitData() {
            if (this.hasLookbookData()) {
                this.title = this.lookbookData.l_title;
                this.parentChange('title', this.title)
                this.content = this.lookbookData.l_content;
                this.parentChange('content', this.content)
                this.p_display = this.lookbookData.l_display;

                this.url = this.lookbookData.l_url;
                this.parentChange('url', this.url)
                this.getYoutubeId();

                this.channelKey = Number(this.lookbookData.lc_idx);
                this.parentChange('channelKey', this.channelKey)

                this.display = Number(this.lookbookData.l_display);
                this.parentChange('display', this.display)


                if (!util.isEmpty(this.lookbookData.Hash)) {
                    util.Array.each(this.lookbookData.Hash, (value, index, arr) => {
                        this.hashtag.push(value.lh_idx);
                    })
                    this.parentChange('hashtag', this.hashtag)
                }
            }
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        returnThumnailUrl() {
            if (!util.isEmpty(this.youtubeId)) {
                return `https://img.youtube.com/vi/${this.youtubeId}/0.jpg`;
            } else {
                return this.url
            }
        },
        getYoutubeId() {
            let url = this.url
            if (util.isEmpty(url)) {
                return false;
            }
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);
            this.youtubeId = (match && match[2].length === 11) ? match[2] : null;
        },
        checkYoutube() {
            return !util.isEmpty(this.youtubeId);
        }

    },
    watch: {},
}
</script>

<style scoped>

</style>
